import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import type { InputBaseProps } from '@mui/material';
import CloseCircleIcon from '@/public/icons/approval/close-circle.svg';
import { ApprovalInputClearButton, ApprovalOutlineInput } from './styles';

type ApprovalClearableInputProps = Omit<
  InputBaseProps,
  'value' | 'onChange'
> & {
  value: string;
  onChange: (next: string) => void;
};

/** 레거시 .input + .btn-delete — 값이 있으면 오른쪽에 지우기(ⓧ), 누르면 비우고 포커스 유지 */
const ApprovalClearableInput = ({
  value,
  onChange,
  className,
  ...rest
}: ApprovalClearableInputProps) => {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);
  return (
    <ApprovalOutlineInput
      {...rest}
      className={['approval-clearable-input', className]
        .filter(Boolean)
        .join(' ')}
      inputRef={inputRef}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      endAdornment={
        value.trim() ? (
          <ApprovalInputClearButton
            type="button"
            aria-label={t('입력 내용 지우기')}
            onClick={() => {
              onChange('');
              inputRef.current?.focus();
            }}
          >
            <CloseCircleIcon />
          </ApprovalInputClearButton>
        ) : undefined
      }
    />
  );
};

export default ApprovalClearableInput;
